const singleRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SINGLE_RECORD_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                error: false,
                errorMessage: null,
                providedQuery: action.data.query
            });
        case 'DONE_GET_SINGLE_RECORD_RESOURCE':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_SINGLE_RECORD_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_SINGLE_RECORD_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                create: null,
                isLoading: false,
                error: false,
                errorMessage: null,
                providedQuery: {}
            });
        default:
            return state;
    }
};

export default singleRecordReducer;
